import React from "react";

const Home = () => {
  return (
    <>
      <section className="home">
        <div className="container flexSB">
          <div className="left row">
            <h1>
              <span>Król</span> Edyp
            </h1>
            <h3>Sofokles</h3>
          </div>
          <div className="right row">
            <div className="img">
              <img src="/assets/2.png" alt="..." />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
